export const autosuggestTypes = {
  UPDATE: 'SUGGESTIONS_UPDATE_VALUE',
  CLEAR: 'SUGGESTIONS_CLEAR_VALUE',
  CLEAR_USER_INPUT: 'USER_INPUT_CLEAR_VALUE',
};
